(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

export var COLOR = {
  white: '#fff',
  offWhite: '#fefefe',
  dark: '#293440',
  gray: {
    darkest: '#565656',
    darker: '#717171',
    base: '#c4c4c4',
    lighter: '#eee',
    lightest: '#f6f6f6'
  },
  primary: {
    base: '#0070f0'
  },
  secondary: {
    base: '#293440'
  },
  error: {
    base: '#db2828',
    lighter: '#fee',
    lightest: '#fff7f7'
  },
  warning: {
    base: '#e4511f',
    lighter: '#ffe5b4',
    lightest: '#fcfaf9'
  },
  info: {
    base: '#213e5e',
    lighter: '#eaf4ff',
    lightest: '#f5faff'
  }
};
export var FONT = {};
export var BORDER = {
  width: {
    sm: '1px',
    md: '2px',
    lg: '4px'
  },
  radius: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px'
  },
  style: {
    solid: '',
    dashed: '',
    none: ''
  }
};
export var SHADOW = {
  soft: '0 0 50px rgba(0, 0, 0, 0.1)',
  lg: '0 0 50px rgba(0, 0, 0, 0.25)'
};
export var SPACE = {
  xxxs: '1px',
  xxs: '2px',
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '48px',
  xxxl: '96px'
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(COLOR, "COLOR", "/home/vsts/work/1/s/src/constants/style.js");
  reactHotLoader.register(FONT, "FONT", "/home/vsts/work/1/s/src/constants/style.js");
  reactHotLoader.register(BORDER, "BORDER", "/home/vsts/work/1/s/src/constants/style.js");
  reactHotLoader.register(SHADOW, "SHADOW", "/home/vsts/work/1/s/src/constants/style.js");
  reactHotLoader.register(SPACE, "SPACE", "/home/vsts/work/1/s/src/constants/style.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();